export const API_URL = "http://localhost:8000/";
export const ASSET_DOMAIN = "http://localhost:8080/";
